<template>
  <el-form class="company-select-panel">
    <div
      class="row">
        <div class="col-md-6 col-sm-4 col-12">
            <el-form-item
              :label="L10n('select-a-company')"
              class="material-style"
            >
              <select-response-auto-complete
                :model="companyID"
                @update:model="$emit('update:companyID', $event)"
                :rules="getValidationRule('required')"
                api="Companies/GetAllDynamic"
                :fields="{id: 'id', title: 'name'}"
                :orderBy="{fields: 'name'}"
                @on-data-value="updateCompany"
              ></select-response-auto-complete>
            </el-form-item>
        </div>
        <div class="d-md-none col-sm-4 col-12">
          <el-form-item
            :label="L10n('tab')"
            class="material-style"
          >
            <select-response
              :model="activeTab"
              @on-change="$emit('changeTab', $event)"
              :data="tabs"
              :fields="{id: 'name', title: 'label'}">
            </select-response>
          </el-form-item>
        </div>
        <div class="col-md-6 col-sm-4 col-12 company-select-panel__controls">
          <button
            v-if="isAvailableToEdit"
            type="button"
            class="btn btn-size-s"
            @click="handleAddNew">
            <i class="fas fa-plus"/> {{L10n('add-a-company')}}
          </button>
        </div>
    </div>
  </el-form>
</template>

<script>
export default {
  name: 'CompanySelectPanel',
  props: {
    companyID: { required: true },
    tabs: { type: Array, required: true },
    activeTab: { type: String, required: true },
    isAvailableToEdit: { type: Boolean }
  },
  methods: {
    handleAddNew () {
      this.$emit('addNew')
    },
    updateCompany (source) {
      let name = source && source.name
      this.$emit('updateCompanyName', name)
    }
  }
}
</script>

<style lang="stylus">
  .company-select-panel{
    background #F2FBFE
    padding 0 15px
    position relative
    z-index 2
    padding-top: 2rem
    padding-bottom: 2rem
  }
  .company-select-panel__controls{
    display flex
    align-items center
    justify-content flex-end
  }
  @media only screen and (max-width: 576px) {
    .company-select-panel__controls{
      button{
        width 100%
      }
    }
  }
</style>
